import { gql } from '@apollo/client';
import { WarrantyErrorInfo } from '../fragments';

export default gql`
  mutation destroyWarrantyError($id: ID!) {
    destroyWarrantyError(id: $id) {
      clientMutationId
      warrantyError {
        ...WarrantyErrorInfo
      }
    }
  }
  ${WarrantyErrorInfo}
`;
